export const  sortOptions = [
    { key: "lowest-price", label: "Price, lowest first" },
    { key: "highest-price", label: "Price, highest first" },
    {
      label: "Alphabetical (A-Z)",
      key: "A-Z",
    },
    {
      label: "Alphabetical (Z-A)",
      key: "Z-A",
    },
    { key: "recently added", label: "Recently Added" },
  ];